export default class StudentsBookletIndex {
    constructor() {
        this.bindEvents();
        this.levelAlertCarousetBulletSpy();
        this.initImageZoom();
    }

    bindEvents() {
        this.scrollSpy = new bootstrap.ScrollSpy(document.body, {
            target: '#booklet-tabs'
        });

        document.querySelectorAll('#booklet-tabs.nav li a').forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const element = document.querySelector(link.getAttribute('href'));
                const offset = window.innerWidth < 768 ? 120 : 60;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: elementPosition - offset,
                    behavior: 'smooth'
                });
                document.querySelectorAll('#booklet-tabs.nav li a').forEach(a => a.classList.remove('active'));
                link.classList.add('active');
            });
        });
    }

    levelAlertCarousetBulletSpy() {
        var scrollContainer = document.querySelector('.horizontal-alert-scroll-container .overflow-auto');
        var bullets = document.querySelectorAll('.alert-level-bullet');
        
        if (scrollContainer && bullets.length) {
            bullets[0].classList.add('active');
            
            scrollContainer.addEventListener('scroll', function() {
                const scrollPosition = scrollContainer.scrollLeft;
                const firstItem = scrollContainer.querySelector('.alert-level-card');
                const itemWidth = firstItem ? firstItem.offsetWidth + 16 : 300 + 12; // width + margin, fallback to default
                const activeIndex = Math.round(scrollPosition / itemWidth);
                
                bullets.forEach((bullet, index) => {
                    bullet.classList.toggle('active', index === activeIndex);
                });
            });
        }
    }

    initImageZoom() {
        // Import the ImageZoom utility
        import('../../monitors_v2/utils/ImageZoom').then(module => {
            const ImageZoom = module.default;
            // Create an instance of the image zoom utility
            this.imageZoom = new ImageZoom();
        });
    }
}